module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-3.99826b19.jpg";